import { useCallback } from 'react'
import { useIntercom } from 'react-use-intercom'
import { capitalize, getUserFullName } from '../helpers/helpers'
import FirebaseApp from '../services/firebaseApp'
import { IUserInterface } from '../models/users/user.interface'

const useIntercomUpdate = () => {
  const { update } = useIntercom()

  const updateIntercomUser = useCallback(
    async (profileData?: IUserInterface | null) => {
      const uid = FirebaseApp.auth.currentUser?.uid ?? null
      const email = FirebaseApp.auth.currentUser?.email ?? null
      const photoUrl = FirebaseApp.auth.currentUser?.photoURL ?? null
      const displayName_ = FirebaseApp.auth.currentUser?.displayName ?? null

      if (!uid || !email) return

      // Get user's name with proper fallbacks
      const getUserName = () => {
        // First try to get full name from profile data
        if (profileData) {
          const fullName = getUserFullName(profileData)
          if (fullName && fullName.trim()) {
            return fullName
          }
        }

        // Fallback to Firebase displayName if available
        if (displayName_ && displayName_.trim()) {
          return displayName_
        }

        // Last resort: extract name from email (before @)
        if (email) {

          return email.split('@')[0].replace(/[._-]/g, ' ')
        }

        return 'User'
      }

      const capitalizeUserType = (userType: string | undefined) => {
        if (!userType) return ''
        return userType.charAt(0).toUpperCase() + userType.slice(1)
      }

      type CustomAttributes = {
        account_type: string
        affiliate_link?: string
      }

      // Initialize default update parameters
      const updateParams = {
        userId: uid,
        email: email,
        name: capitalize(getUserName(), {
          capitalizeAll: false,
        }),
        avatar: {
          type: 'avatar' as const,
          imageUrl: photoUrl ?? undefined,
        },
        customAttributes: {
          account_type: capitalizeUserType(profileData?.userType),
        } as CustomAttributes,
      }

      try {
        // const result = await httpService({
        //   url: `get_affiliate_object?email=${encodeURIComponent(email || '')}`,
        //   method: 'GET',
        // })

        // If success - add the affiliate link to the update params
        // if (result?.data?.[0]?.links?.[0]?.url) {
        //   updateParams.customAttributes.affiliate_link = result.data[0].links[0].url
        // }
      } catch (error) {
        // Log the error but continue without the affiliate data
        console.error('Could not fetch affiliate data:', error)
      }

      // Update Intercom with the user data
      update(updateParams)
    },
    [update]
  )

  return { updateIntercomUser }
}

export default useIntercomUpdate
